import React, { Suspense, lazy } from "react";
//import { Helmet } from "react-helmet";
// import Page from "../components/privacy-policy";
const Page= lazy(() =>
  import("../components/privacy-policy")
);

export default function PrivacyPolicy() {
  return (
    <div>
      {/* <Page /> */}
      <Suspense fallback={null}>
        <Page />
      </Suspense>
    </div>
  );
}
